import styled from 'styled-components'

export interface FlexProps {
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'self-start' | 'self-end' | 'baseline' | 'stretch' | 'normal';
  alignContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'baseline' | 'stretch';
  gap?: string;
  maxWidth?: boolean;
  maxHeight?: boolean;
  overflowY?: string;
  margin?: string;
  padding?: string;
}

const Flex = styled('div') <FlexProps>`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  flex-wrap: ${props => props.flexWrap || 'nowrap'};
  justify-content: ${props => props.justifyContent || 'center'};
  align-items: ${props => props.alignItems || 'center'};
  align-content: ${props => props.alignContent || 'center'};
  gap: ${props => props.gap || 'initial'};
  width: ${props => props.maxWidth ? '100%' : 'auto'};
  height: ${props => props.maxHeight ? '100%' : 'auto'};
  overflow-y: ${props => props.overflowY || 'visible'};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0'};
`

export default Flex
